import React from 'react'

import TimelineSkeleton from '../Skeleton'

const TRIGGER_HEIGHT = 500

const calcTopMax = e => {
  const { scrollHeight, clientHeight, scrollTopMax } = e.target

  if (scrollTopMax) {
    return scrollTopMax
  }

  return scrollHeight - clientHeight - 10
}

const Infinite = ({ id, containerRef, getData, onDataFetched, children }) => {
  const [loading, setLoading] = React.useState(false)
  const [done, setDone] = React.useState(false)

  const onScroll = React.useCallback(
    e => {
      if (done || loading) {
        return
      }

      // Loads the next set of data
      const loadMore = async () => {
        try {
          setLoading(true)
          const { data, extra } = await getData(id)
          e.target.scrollTop = calcTopMax(e) - offset
          onDataFetched && onDataFetched(data, extra)
          setLoading(false)

          if (!extra?.next) {
            setDone(true)
          }
        } catch (err) {
          console.error('Error loading timeline', err)
        }
      }

      const { scrollTop: height } = e.target
      const max = calcTopMax(e)
      const offset = max - height

      // Load more when near the top
      if (height <= TRIGGER_HEIGHT) {
        loadMore()
      }
    },
    [done, loading, getData, id, onDataFetched]
  )

  React.useEffect(() => {
    const ref = containerRef?.current
    if (!ref) {
      return
    }

    ref.addEventListener('scroll', onScroll)

    return () => {
      ref.removeEventListener('scroll', onScroll)
    }
  }, [containerRef, onScroll])

  return (
    <>
      {loading && <TimelineSkeleton />}

      {children}
    </>
  )
}

export default Infinite
